import { useRouter } from "next/router";
import { useTeams } from "queries/teams";
import { isDev } from "ui/lib/helpers";
import { SECTION_NAMES, SHELL_NAMES, TOOL_NAMES } from "apollo/lib/strings";

const PAGE_LABELS: Record<string, string> = {
  "/programs/[bootcampId]/overview": SECTION_NAMES.calendar,
  "/programs/[bootcampId]/chat": SECTION_NAMES.chat,
  "/programs/[bootcampId]/movements": SECTION_NAMES.movements,
  "/programs/[bootcampId]/members": TOOL_NAMES.members,
  "/programs/[bootcampId]/workout/[workoutId]": "Workout",
  "/programs/[bootcampId]/details": SECTION_NAMES.details,
  "/programs/[bootcampId]/details/movements": "Movement library",
  "/programs/[bootcampId]/details/imagery": "Workout imagery",
  "/programs/[bootcampId]/details/equipment": "Equipment",
  "/programs/[bootcampId]/details/lessons": "Lessons",
  "/members/[memberId]": "Member",
  "/blocks": TOOL_NAMES.blocks,
  "/blocks/[blockId]": "Block",
  "/open-season": TOOL_NAMES.openSeason,
  "/curated-rooms": TOOL_NAMES.curatedRooms,
  "/home-shelves": TOOL_NAMES.homeShelves,
  "/remote-config": TOOL_NAMES.remoteConfig,
  "/links/builder": TOOL_NAMES.ladderLinks,
  "/promos": TOOL_NAMES.promos,
  "/badges": TOOL_NAMES.badges,
  "/more": SHELL_NAMES.more,
  "/[...notFound]": "Page not found",
};

export const pageLabel = (pathname: string) => PAGE_LABELS[pathname];

/** "Calendar · Crews Control · Apollo": the page, then the team when the route has one. Dev tabs end "Apollo Dev". */
export const usePageTitle = (label?: string) => {
  const { pathname, query } = useRouter();
  const bootcampId =
    typeof query.bootcampId === "string" ? query.bootcampId : null;
  const { getTeamById } = useTeams();
  const team = bootcampId ? getTeamById(bootcampId)?.name : undefined;
  const app = isDev ? "Apollo Dev" : "Apollo";
  return [label ?? pageLabel(pathname), team, app].filter(Boolean).join(" · ");
};
